"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageContentType = /** @class */ (function () {
    function MessageContentType() {
    }
    MessageContentType.RichText = "RichText";
    MessageContentType.Text = "Text";
    return MessageContentType;
}());
exports.default = MessageContentType;
//# sourceMappingURL=MessageContentType.js.map